





































































import Vue from "vue";
import {
  IndividualCareProviderByType,
  IndividualCareProviderType,
} from "@/@modules/tarif-covid/interfaces/IndividualCareProvider";
import { RunRef } from "@/@modules/tarif-covid/interfaces/RunRef";
import { Period } from "@/@modules/tarif-covid/interfaces/Period";
import { RestService } from "@/@modules/tarif-covid/services";
import { YearMonthType } from "@/@modules/tarif-covid/interfaces/YearMonthType";

export default Vue.extend({
  props: {
    individualCareProviders: {
      type: Array as () => IndividualCareProviderByType[],
      required: true,
    },
    currentRunRef: {
      type: Object as () => RunRef,
      required: true,
    },
    periods: {
      type: Array as () => Period[],
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    size: {
      type: Number,
      default: 6,
    },
  },
  computed: {
    individualCareProviderE2_5(): IndividualCareProviderByType[] {
      return this.individualCareProviders.filter(icp => {
        return icp.type == IndividualCareProviderType.ENCOUNTER2_5;
      });
    },
    individualCareProviderE20(): IndividualCareProviderByType[] {
      return this.individualCareProviders.filter(icp => {
        return icp.type == IndividualCareProviderType.ENCOUNTER20;
      });
    },
    individualCareProviderF(): IndividualCareProviderByType[] {
      return this.individualCareProviders.filter(icp => {
        return icp.type == IndividualCareProviderType.FORFAIT;
      });
    },
    E201912Headers(): any {
      return this.E2_5Headers.filter((header: any) => {
        return header.value != "month" && header.value != "comment";
      });
    },
    E2_5Headers(): any {
      return [
        {
          text: this.$t("tarif-covid.month"),
          value: "month",
          sortable: false,
        },
        ...this.individualCareProviderE2_5.flatMap(individualCareProvider => {
          return {
            text: individualCareProvider.nihdi,
            value: individualCareProvider.nihdi,
            sortable: false,
            nihdi: true,
          };
        }),
        ...(this.individualCareProviderE2_5.length > 1
          ? [
              {
                text: this.$t("tarif-covid.total"),
                value: "total",
                sortable: false,
              },
            ]
          : []),
        {
          text: this.$t("tarif-covid.comment"),
          value: "comment",
          sortable: false,
        },
      ];
    },
    E20Headers(): any {
      return [
        {
          text: this.$t("tarif-covid.month"),
          value: "month",
          sortable: false,
        },
        ...this.individualCareProviderE20.flatMap(individualCareProvider => {
          return {
            text: individualCareProvider.nihdi,
            value: individualCareProvider.nihdi,
            sortable: false,
            nihdi: true,
          };
        }),

        ...(this.individualCareProviderE20.length > 1
          ? [
              {
                text: this.$t("tarif-covid.total"),
                value: "total",
                sortable: false,
              },
            ]
          : []),
        {
          text: this.$t("tarif-covid.comment"),
          value: "comment",
          sortable: false,
        },
      ];
    },
    FHeaders(): any {
      return [
        {
          text: this.$t("tarif-covid.month"),
          value: "month",
          sortable: false,
        },
        {
          text: this.$t("tarif-covid.forfaitRight"),
          value: "forfaitRight",
          sortable: false,
        },
      ];
    },
    E201912Items(): any {
      return this.E2_5Items.filter((item: any) => {
        return this.E201912Headers.find((header: any) => {
          return !!item[header.value];
        });
      });
    },
    E2_5Items(): any {
      const res: any = this.periods
        .find(period => {
          return period.code == this.currentRunRef.of?.code;
        })
        ?.months?.map(r => {
          return { month: this.parseMonth(r), time: r, total: 0 };
        });
      let matchItems = false;
      this.individualCareProviderE2_5.forEach(icp => {
        if (icp.encounters && icp.encounters[this.currentRunRef.of?.code as string]) {
          icp.encounters[this.currentRunRef.of?.code as string][this.currentRunRef.nr as number]?.forEach(encounter => {
            matchItems = true;
            const r: any = res.find((r: any) => {
              return r.time.month == Number(encounter.month?.substr(4,2)) && r.time.year == Number(encounter.month?.substr(0, 4));
            });
            r[icp.nihdi as string] = encounter.count;
            r.comment = (r.total += encounter.count) >= 200 ? this.$t("tarif-covid.payments-details.maxReached", {max: 200}) : undefined;
          });
        }
      });
      return matchItems ? res : undefined;
    },
    E20Items(): any {
      const res: any = this.periods
        .find(period => {
          return period.code == this.currentRunRef.of?.code;
        })
        ?.months?.map(r => {
          return { month: this.parseMonth(r), time: r, total: 0 };
        });
      let matchItems = false;
      this.individualCareProviderE20.forEach(icp => {
        if (icp.encounters && icp.encounters[this.currentRunRef.of?.code as string]) {
          icp.encounters[this.currentRunRef.of?.code as string][this.currentRunRef.nr as number]?.forEach(encounter => {
            matchItems = true;
            const r: any = res.find((r: any) => {
              return r.time.month == Number(encounter.month?.substr(4,2)) && r.time.year == Number(encounter.month?.substr(0, 4));
            });
            r[icp.nihdi as string] = encounter.count;
            r.comment = (r.total += encounter.count) >= 200 ? this.$t("tarif-covid.payments-details.maxReached", {max: 200}) : undefined;
          });
        }
      });
      return matchItems ? res : undefined;
    },
    FItems(): any {
      const res: any = this.periods
        .find(period => {
          return period.code == this.currentRunRef.of?.code;
        })
        ?.months?.map(r => {
          return { month: this.parseMonth(r), time: r };
        });
      let matchItems = false;
      this.individualCareProviderF.forEach(icp => {
        if (icp.forfaits && icp.forfaits[this.currentRunRef.of?.code as string]) {
          icp.forfaits[this.currentRunRef.of?.code as string][this.currentRunRef.nr as number]?.forEach(forfait => {
            matchItems = true;
            const r: any = res.find((r: any) => {
              return r.time.month == Number(forfait.month?.substr(4,2)) && r.time.year == Number(forfait.month?.substr(0, 4));
            });
            r.forfaitRight = true;
          });
        }
      });
      return matchItems ? res : undefined;
    },
  },
  methods: {
    async downloadFile(nihdi: string, applicationType: string) {
      if (this.currentRunRef.nr && this.currentRunRef.of?.code) {
        const fileAsBlob = await RestService.downloadFile(nihdi, this.currentRunRef.nr, this.currentRunRef.of.code, applicationType, `encounters`);
        const blob = new Blob([fileAsBlob]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        const now = new Date();
        const currentMonth = (now.getMonth() + 1).toString()
        const currentDay = now.getDate().toString();
        const yyyyMMdd = `${now.getFullYear().toString()}${currentMonth.length == 1 ? '0' + currentMonth : currentMonth}${currentDay.length == 1 ? '0' + currentDay : currentDay}`;
        link.download = `${nihdi}_Period ${this.currentRunRef.of.code}_RUN ${this.currentRunRef.nr}_Export ${yyyyMMdd}.${applicationType}`;
        link.click();
      }
    },
    parseMonth(time: YearMonthType) {
      switch (time.month) {
        case 1: {
          return `${this.$t("month.january")} ${time.year}`;
        }
        case 2: {
          return `${this.$t("month.february")} ${time.year}`;
        }
        case 3: {
          return `${this.$t("month.march")} ${time.year}`;
        }
        case 4: {
          return `${this.$t("month.april")} ${time.year}`;
        }
        case 5: {
          return `${this.$t("month.may")} ${time.year}`;
        }
        case 6: {
          return `${this.$t("month.june")} ${time.year}`;
        }
        case 7: {
          return `${this.$t("month.july")} ${time.year}`;
        }
        case 8: {
          return `${this.$t("month.august")} ${time.year}`;
        }
        case 9: {
          return `${this.$t("month.september")} ${time.year}`;
        }
        case 10: {
          return `${this.$t("month.october")} ${time.year}`;
        }
        case 11: {
          return `${this.$t("month.november")} ${time.year}`;
        }
        case 12: {
          return `${this.$t("month.december")} ${time.year}`;
        }
      }
    },
  },
});
